export const schemaFormSchemaSelector = (state) => state?.dataStore?.schemaFormSchema;
